import { connect } from "react-redux";
import { RootState } from "store/store";

import { setModalLoaderVisibility } from "store/common/modal-window/modal-window-slices";
import { getActiveEnvironmentMoniker } from "store/environments/environment-selectors";
import {
    setIsUnsavedChangeAvailable,
    setModalConfirmCallback,
} from "store/common/unsaved-data/unsaved-data-actions";
import { setRefreshActivated } from "store/common/page-refresh/page-refresh-actions";

import GuestTenantConsents from "./GuestTenantConsents";

const mapStateToProps = (state: RootState) => {
    return {
        envMoniker: getActiveEnvironmentMoniker(state),
        isUnsavedChangeAvailable:
            state.unsavedDataReducer.isUnsavedChangeAvailable,
    };
};

const GuestTenantConsentsContainer = connect(mapStateToProps, {
    setModalLoaderVisibility,
    setModalConfirmCallback,
    setRefreshActivated,
    setIsUnsavedChangeAvailable,
})(GuestTenantConsents);

export default GuestTenantConsentsContainer;
